import { INBOX_TYPES } from 'shared/mixins/inboxMixin';

export const getInboxClassByType = (type, phoneNumber) => {
  switch (type) {
    case INBOX_TYPES.WEB:
      return 'globe-desktop';

    case INBOX_TYPES.FB:
      return 'brand-facebook';

    case INBOX_TYPES.TWITTER:
      return 'brand-twitter';

    case INBOX_TYPES.TWILIO:
      return phoneNumber?.startsWith('whatsapp')
        ? 'brand-whatsapp'
        : 'brand-sms';

    case INBOX_TYPES.WHATSAPP:
      return 'brand-whatsapp';

    case INBOX_TYPES.API:
      return 'cloud';

    case INBOX_TYPES.EMAIL:
      return 'mail';

    case INBOX_TYPES.TELEGRAM:
      return 'brand-telegram';

    case INBOX_TYPES.LINE:
      return 'brand-line';

    case INBOX_TYPES.INTERTEL_UC:
      return 'brand-conversa';

    // WhatsApp vinculado (Evolution API): visor de escaneo (marco con esquinas y barra central).
    // fluent-icon le agrega el sufijo "-outline" al buscarlo en dashboard-icons.json.
    case INBOX_TYPES.EVOLUTION_API:
      return 'brand-whatsapp-linked';

    default:
      return 'chat';
  }
};

export const getInboxWarningIconClass = (type, reauthorizationRequired) => {
  if (type === INBOX_TYPES.FB && reauthorizationRequired) {
    return 'warning';
  }
  if (type === INBOX_TYPES.EVOLUTION_API && reauthorizationRequired) {
    return 'warning';
  }
  if (type === INBOX_TYPES.WHATSAPP && reauthorizationRequired) {
    return 'warning';
  }
  return '';
};
